import React from "react"
import types from "prop-types"
import { taskShape } from "utils/propTypeShapes"
import { MULTI_ENTRIES_TYPE } from "Forms/FormElementTypes"
import { makeQuestion } from "utils/formDataHelpers"
import { GENERAL_TASK_MULTI_ENTRY_QUESTION_UUID } from "./constants"
import TaskCompletedGeneralTask from "./TaskCompletedGeneralTask"
import TaskOpenGeneralTask from "./TaskOpenGeneralTask"

const multiEntryQuestion = () => makeQuestion({
  uuid: GENERAL_TASK_MULTI_ENTRY_QUESTION_UUID,
  type: MULTI_ENTRIES_TYPE,
})

const TaskGeneralResponse = ({ task, taskControls }) => {
  const { isOpen } = task
  const generalTaskQuestion = multiEntryQuestion()

  return (
    isOpen
      ? <TaskOpenGeneralTask generalTaskQuestion={generalTaskQuestion} task={task} taskControls={taskControls} />
      : <TaskCompletedGeneralTask generalTaskQuestion={generalTaskQuestion} task={task} taskControls={taskControls} />
  )
}

TaskGeneralResponse.propTypes = {
  task: taskShape.isRequired,
  taskControls: types.node.isRequired,
}

export default TaskGeneralResponse
